import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
} from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { IconComponent } from '@fcom/ui-components';

import { DynamicComponentFactory } from '../../factories/dynamic-component.factory';
import { transformListContent } from '../../utils';

@Component({
  selector: 'fin-dynamic-html',
  template: '',
})
export class DynamicHtmlComponent implements AfterViewInit, OnDestroy {
  private readonly factories: DynamicComponentFactory<IconComponent>[] = [];
  private readonly hostElement: Element;

  @Input()
  innerHtml = '';

  components = [IconComponent];

  constructor(
    elementRef: ElementRef,
    private appRef: ApplicationRef,
    private injector: Injector,
    private resolver: ComponentFactoryResolver
  ) {
    this.hostElement = elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.hostElement.innerHTML = transformListContent(this.innerHtml, SvgLibraryIcon.CHECKMARK);
    this.initFactories();
    this.createAllComponents();
  }

  ngOnDestroy(): void {
    this.removeAllComponents();
  }

  private initFactories(): void {
    this.components.forEach((component) => {
      const factory = this.resolver.resolveComponentFactory(component);
      const dynamicComponentFactory = new DynamicComponentFactory(this.appRef, factory, this.injector);
      this.factories.push(dynamicComponentFactory);
    });
  }

  private createAllComponents(): void {
    this.factories.forEach((factory) => {
      factory.createDynamicComponents(this.hostElement);
    });
  }

  private removeAllComponents(): void {
    this.factories.forEach((factory) => factory.destroy());
  }
}
